export default __webpack_public_path__ + "static/media/night.6f9e027e.svg";